import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { useTheme } from '../../../theme/ThemeProvider';
import Card, { cardStyles } from '../../../components/ui/Card/Card';
import { axisTheme, tooltipStyle, tooltipText } from '../chartTheme';
import styles from './BarDistributionCard.module.css';

export interface BarDatum {
  name: string;
  value: number;
}

interface BarDistributionCardProps {
  title: string;
  data: BarDatum[];
  color: string;
  footer?: string;
}

const BarDistributionCard: React.FC<BarDistributionCardProps> = ({
  title,
  data,
  color,
  footer,
}) => {
  const { resolvedTheme } = useTheme();
  const { axis, grid } = axisTheme(resolvedTheme);

  return (
    <Card>
      <div className={cardStyles.header}>
        <h3 className={cardStyles.title}>{title}</h3>
      </div>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ top: 6, right: 6, left: -20, bottom: 4 }}>
          <CartesianGrid stroke={grid} vertical={false} />
          <XAxis
            dataKey="name"
            tick={{ fill: axis, fontSize: 9 }}
            tickLine={false}
            axisLine={{ stroke: grid }}
            interval={0}
            angle={-90}
            textAnchor="end"
            height={90}
          />
          <YAxis
            tick={{ fill: axis, fontSize: 11 }}
            tickLine={false}
            axisLine={false}
            width={40}
          />
          <Tooltip
            cursor={{ fill: 'rgba(128,128,128,0.08)' }}
            contentStyle={tooltipStyle(resolvedTheme)}
            labelStyle={tooltipText(resolvedTheme)}
            itemStyle={tooltipText(resolvedTheme)}
          />
          <Bar dataKey="value" fill={color} radius={[4, 4, 0, 0]} maxBarSize={38} />
        </BarChart>
      </ResponsiveContainer>
      {footer && <p className={styles.footer}>{footer}</p>}
    </Card>
  );
};

export default BarDistributionCard;
